<template>
	<div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">基本信息</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">基本资料</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn">
          请完善以下信息，方便我们更好的为您服务！
        </div>
        <form ref="form" class="zj-form form-horizontal" action="" style="visibility:hidden">
          <div class="form-group ub-box">
            <div class="zj-control-label">
              会员ID：
            </div>
            <div class="zj-form-control validate-control">
              {{userInfo.userid}}
              <span class="error-reminder"></span>
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">
              联系人：
            </div>
            <div class="zj-form-control validate-control">
              <xfrom-input width="width360" v-model="userInfo.linkman"/>
              <span class="error-reminder"></span>
            </div>
          </div>
          <div class="form-group choose-verify-method ub-box">
            <div class="zj-control-label">
              电话：
            </div>
            <div class="zj-form-control validate-control">
              <xfrom-input width="width360" v-model="userInfo.linktel"/>
              <span class="error-reminder"></span>
            </div>
          </div>
          <div class="form-group choose-verify-method ub-box">
            <div class="zj-control-label">
              QQ：
            </div>
            <div class="zj-form-control">
              <xfrom-input inpwidth="width360" v-model="userInfo.qq"/>
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">
              绑定手机：
            </div>
            <div class="zj-form-control">
              <div class="zj-form-control-container">
                <xfrom-input bccolor="hui" inpwidth="width268" readonly notallowed v-model="user.phone"/>
                <a class="zj-btn btn-primary" @click="bindPhone">前往绑定</a>
              </div>
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">
              绑定邮箱：
            </div>
            <div class="zj-form-control">
              <div class="zj-form-control-container">
                <xfrom-input bccolor="hui" inpwidth="width268" readonly notallowed v-model="user.email"/>
                <a class="zj-btn btn-primary" @click="bindEmail">前往绑定</a>
              </div>
            </div>
          </div>
          <div class="form-group ub-box">
            <div class="zj-control-label">
              &nbsp;
            </div>
            <div class="zj-form-control">
              <a href="javascript:;" class="zj-btn btn-strong" @click="savingInfo">保 存</a>
            </div>
          </div>
        </form>
      </div>
    </div>
	</div>
</template>
<script>
/*import userService from 'business/userService.js'*/
import XfromInput from 'commons/XfromInput.vue'
import Xcity from 'commons/Xcity.vue'
import userService from 'business/userService.js'
export default {
  data () {
    return {
      DISTRICTS:[],
      listLoading:false,
      userInfo: {
        cmd: 'modifyinfo',
        address:'',
        linkman: '',
        linktel: '',
        qq: '',
        userid: ''
      },
      user: {
        cname: '',
        phone:'',
        email:'',
      },
      cityInfo: {
        province:'中国',
        city:'北京',
        area:'北京市'
      },
      cityId:{
        provinceid: 0,
        cityid: 1,
        districtid: 1
      }
    }
  },
  components: {
    XfromInput,
    Xcity
  },
  props:{
    hide:Boolean
  },
  mounted(){
    this.config()
  },
  methods: {
    async config() {
      await this.getAllUser('userInfo','cmd=userinfo')
    },
    async getAllUser(urlType,data) {
      let {vueData, state} = await userService.transformToVue(urlType,'POST',data)
      if(state.code === '000' ) {
        let msg = vueData.msg

        this.userInfo.userid = msg.userid

        this.userInfo.address = msg.Address ? msg.Address : ''
        this.userInfo.linkman = msg.Linkman ? msg.Linkman : ''
        this.userInfo.linktel = msg.LinkTel ? msg.LinkTel : ''
        this.userInfo.qq = msg.qq

        this.user.cname = msg.cName
        this.user.phone = msg.ID_Mobile
        this.user.email = msg.ID_Email


        this.$refs.form.style.visibility = 'visible'
      }else {
        this.$toast('请刷新页面...','fail')
      }
    },
    async savingInfo() {

      let data = 'cmd='+this.userInfo.cmd+'&linkman='+this.userInfo.linkman+'&linktel='+this.userInfo.linktel+'&qq='+this.userInfo.qq
      let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
      if(vueData.response == 200 ) {
        this.$toast(vueData.msg,'success')

      }else {
        this.$toast(vueData.msg,'fail')
      }
    },
    bindPhone() {
      this.$router.push('./user4')
    },
    bindEmail() {
      this.$router.push('./user5')
    },
  }
}
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  a {
    text-decoration: none;
  }
  .crumb-home {
    padding-left: 28px;
    background: url(../../assets/imgs/zhanghu.png) no-repeat left center;
  }
  .zj-form {
    padding-top: 20px;
    color: #ccc;
  }
  .zj-form .form-group {
    margin-bottom: 12px;
    line-height: 30px;
    padding: 5px 0;
  }
  .form-horizontal .form-group {
    margin-right: -15px;
    margin-left: -15px;
  }
  .zj-control-label {
    width: 135px;
    padding-right: 0;
    text-align: right;
    color: #666;
    min-width: 135px;
    font-size: 14px;
    padding-right: 20px;
  }
  .zj-form-control{
    padding-right: 5px;
    padding-left: 5px;
    white-space: nowrap;
    color: #333;
    background-color: #fff;
    background-image: none;
    outline: none;
    font-size: 14px;
  }
  .zj-form-control-container {
    width: 378px;
  }
  .user-label {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: no-repeat center;
    vertical-align: -8%;
  }
  .auth_inauth {
    background-image: url(../../assets/imgs/auth_inauth.png);
  }
  .zj-form-control .btn-primary {
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    border: 1px solid #009fd9;
    color: #009fd9;
    padding: 0 12px;
    float: right;
  }
  .zj-form-control .btn-primary:hover {
    background-color: #d6f4ff;
  }
  .btn-strong {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    border: none;
    padding: 0 30px;
    background-color: #04baf0;
    outline: none;
    color: #fff;
  }
  .zj-form zj-btn {
    font-size: 12px;
  }
  .zj-btn {
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
  }
  .btn-strong:hover, .btn-strong:focus {
    color: #fff;
    text-decoration: none;
    background-color: #04baf0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/user/user1.vue